/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiUnbilledContainerRentGroup } from '@Model';
import type { HttpActions, ListInfo, ListRequest, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ContainerRentController.
 */
export class ContainerRentRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /containers/rent/unbilled/groups:query
     */
    public getUnbilled(listRequest: ListRequest, billedFrom: string | undefined, billedUntil: string | undefined): Promise<Result<ListInfo<ApiUnbilledContainerRentGroup>>> {
        const query = new URLSearchParams();
        if (billedFrom !== undefined) {
            query.set('billed_from', `${billedFrom}`);
        }
        if (billedUntil !== undefined) {
            query.set('billed_until', `${billedUntil}`);
        }

        return this.http.post<Result<ListInfo<ApiUnbilledContainerRentGroup>>, ListRequest>('/containers/rent/unbilled/groups:query', listRequest, query);
    }
}
